

export default class ClothesChangerGalleryCache {
    static CACHE_NAME = "mockofun-clothes-changer";
    static GALLERY_ENDPOINT = "/clothes-changer/gallery/";
    async storeGalleryImage(src,imgFileName){
        const cache = await caches.open(ClothesChangerGalleryCache.CACHE_NAME);
        const response = new Response(JSON.stringify({src}));
        await cache.put(ClothesChangerGalleryCache.GALLERY_ENDPOINT+imgFileName, response);
    }
    async removeGalleryImage(imgFileName){
        const cache = await caches.open(ClothesChangerGalleryCache.CACHE_NAME);
        await cache.delete(ClothesChangerGalleryCache.GALLERY_ENDPOINT+imgFileName);
    }
    async listGalleryStore(){
        const cache = await caches.open(ClothesChangerGalleryCache.CACHE_NAME);
        var keys = await cache.keys();
        keys = keys.map(k => k.url).filter(url => url.match(/.*?\/clothes-changer\/gallery\/.*?/));
        var responses = await keys.map(async k => await cache.match(k))
                // .map(async r => 
                //     {
                //         var response = await r;
                //         var data = await response.text();
                //         return data.src;
                //     }
                // );
        responses = await Promise.all(responses);
        responses = responses.map(async r => {
            var response = await r;
            var data = JSON.parse(await response.text());
            return data.src;
        });
        responses = await Promise.all(responses);
        // console.log(responses);
        return responses;
    }
}

